import React from 'react';
import { Link } from 'react-router-dom';

import BooksetList from 'rebook/apps/catalog/components/BooksetList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SearchBooksetlist = ({ booksetList, booksetsCount, query }) => (
  <div className={styles.section}>
    <div className="title-1">Подборки</div>
    {booksetsCount > 2 && (
      <Link className="cy-search-all-series"
        to={{
          pathname: `/search/booksets/`,
          state: { booksetList, booksetsCount, query },
          search: `?q=${query}` }}>
        <div className="link">
          {booksetsCount} {pluralize(booksetsCount, 'подборка', 'подборки', 'подборок')}
        </div>
      </Link>
    )}
    <div className={styles.content}>
      <BooksetList booksets={booksetList.slice(0, 2)} />
    </div>
  </div>
);

export default SearchBooksetlist;
